<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Dealer FOTA</span>
    </div>
    <!-- Redirect Button -->
    <div class="button-group">
      @if (DealerFotaCreate) {
        <button
          type="button"
          class="primary-button"
          [routerLink]="['/dealer-fota-approved-files']"
        >
          Add Approved File
          <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
    </div>
  </div>

  <div class="component-container">
    <!-- List Section -->
    <form [formGroup]="dealerFOTAForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">Dealer FOTA List</h6>
        <div class="component-actions">
          <button
            type="button"
            class="primary-button"
            [disabled]="isDownloading"
            (click)="downloadDealerFotaReport()"
          >
            Download Dealer FOTA Details<mat-icon class="btn-icon"
              >download</mat-icon
            >
          </button>
          <app-common-search
            [initialSearchValue]="dealerFOTAForm?.get('modelListSearch')?.value"
            matTooltip="File Name | UIN NO. | VIN NO."
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>File Name</th>
              <th>UIN NO.</th>
              <th>VIN NO.</th>
              <th>Flashing Status</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            @for (
              item of dealerFota
                | paginate
                  : {
                      id: 'batchPaginate',
                      itemsPerPage: size,
                      currentPage: page,
                      totalItems: totalCount,
                    };
              track item;
              let i = $index
            ) {
              <tr>
                <td>{{ size * (page - 1) + i + 1 }}</td>
                <td>{{ item.file_name ? item.file_name : '--' }}</td>
                <td>{{ item.uin ? item.uin : '--' }}</td>
                <td>{{ item.vin ? item.vin : '--' }}</td>
                <td>
                  {{ item.flashing_status ? item.flashing_status : '--' }}
                </td>
                <td>{{ item.createdAt }}</td>
              </tr>
            }
          </tbody>
          @if (totalCount === 0) {
            <tbody>
              <tr>
                <td colspan="10">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (totalCount !== 0) {
          <app-common-component-pagination
            [totalItems]="totalCount"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalCount"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </form>
  </div>
</div>
